import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createTaskStatusAsync, updateTaskStatusAsync, selectTaskStatusBySqId } from '../../slice/taskStatusSlice';
import {ReactComponent as OK} from '../../assets/ok.svg';
import { useThemeColor } from '../../hooks/useThemeColor';

const SQ = ({ question, index, onDescriptionSelect, historyId, isActive = false, readOnly = false, disabled = false }) => {
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => selectTaskStatusBySqId(state, question?.id, historyId));
    const { primaryColor } = useThemeColor();
    const [isClicked, setIsClicked] = useState(false);

    // `disabled` (a response is still in flight for this chat — see
    // Sidebar.jsx's `questionsSendDisabled`) is distinct from `readOnly`
    // (viewing someone else's shared/read-only chat): unlike readOnly, this
    // is temporary and lifts as soon as the previous response settles.
    const handleClick = () => {
        if (readOnly || disabled) return;
        setIsClicked(true);
        if (onDescriptionSelect) onDescriptionSelect(question);
        const taskStatusData = {
            history_id: historyId,
            sq_id: question?.id,
            status: true
        };
        if (taskStatus) {
            dispatch(updateTaskStatusAsync(taskStatusData));
        } else {
            dispatch(createTaskStatusAsync(taskStatusData));
        }
    };

    const isHighlighted = !readOnly && (isClicked || isActive || taskStatus?.status)

    return (
        <div
            onClick={handleClick}
            className={`p-5 rounded-lg flex flex-col gap-3 transition-colors duration-150 ${
                readOnly || disabled ? 'cursor-default' : 'cursor-pointer'
            } ${
                isHighlighted
                    ? 'bg-white border border-custom-yellow'
                    : 'bg-custom-gray_white border border-transparent'
            } ${readOnly ? 'select-none' : ''} ${disabled ? 'opacity-50' : ''}`}
            data-active={isActive ? 'true' : 'false'}
            id={`question-${question?.id}`}
        >
            <div className='flex justify-between items-center'>
                <h1 className={`text-lg font-semibold ${readOnly ? 'text-[#9CA3AF]' : 'text-black'}`}>
                    {question?.title}
                </h1>
                <div className={readOnly ? 'text-[#D1D5DB]' : taskStatus?.status ? 'text-custom-yellow' : 'text-[#5F6368]'}>
                    <OK className="w-6 h-6" />
                </div>
            </div>
            <p className='text-gray-500 max-w-sm'>
                {question?.description}
            </p>
        </div>
    );
};

export default SQ;